module.exports = __webpack_public_path__ + "static/media/climatizacion-coche.4818c168.png";